import { render } from "./PortfolioStategy.vue?vue&type=template&id=b3dfe0f4&scoped=true"
import script from "./PortfolioStategy.vue?vue&type=script&lang=js"
export * from "./PortfolioStategy.vue?vue&type=script&lang=js"

import "./PortfolioStategy.vue?vue&type=style&index=0&id=b3dfe0f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dfe0f4"]])

export default __exports__